import React, { useState } from 'react';
import Countdown from '../Countdown/Countdown';
import ReactTooltip from 'react-tooltip';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../constants';
import { TRANSLATIONS } from '../../../translations';
import ModalDrawer from '../modals/ModalDrawer';
import XmasContestModal from './XmasContestModal';

const BlackFridayBanner = ({ startDate, endDate, copy, code }) => {
  if (window.location.href.includes('checkout')) {
    return null;
  }

  const isDeviceSmallerThanTablet = !useMatchesMinWidth(768);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Detect if we're on a listing page
  const isListingPage = document.querySelector('[data-overlay-widget="booking-form"]') !== null;

  const locale = window.freedomeConfig.locale || 'en';
  const stringCopied = {
    en: 'Copied!',
    it: 'Copiato!',
    es: '¡Copiado!',
  };

  // Check if countdown should be visible (within 48 hours of deadline)
  const startDateObj = new Date(startDate);
  const targetDate = new Date(endDate);
  const currentDate = new Date();
  const timeUntilEnd = targetDate - currentDate;
  const fortyEightHours = 48 * 60 * 60 * 1000;
  const showCountdown = startDate && endDate &&
    currentDate >= startDateObj &&
    targetDate >= startDateObj &&
    timeUntilEnd <= fortyEightHours &&
    timeUntilEnd > 0;

  const handleCtaClick = (e) => {
    if (isListingPage) {
      e.preventDefault();
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <div className={`black-friday__banner`}>
        <span className="d-flex flex-wrap gap-base">
          🎁{' '}{copy}{' '}{code}
          {showCountdown && (
            <span className="black-friday__banner__counter-wrapper">
              <Countdown start={startDate} end={endDate} />
            </span>
          )}
        </span>

        <a
          href={TRANSLATIONS.BLACK_FRIDAY_URL}
          className='beta-btn beta-btn--primary beta-btn--xs'
          onClick={handleCtaClick}
        >
          {isDeviceSmallerThanTablet ? TRANSLATIONS.BLACK_FRIDAY_CTA_MOBILE : TRANSLATIONS.BLACK_FRIDAY_CTA}
        </a>
      </div>

      {isListingPage && (
        <ModalDrawer
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          isDeviceSmallerThanTablet={isDeviceSmallerThanTablet}
          content={<XmasContestModal isDeviceSmallerThanTablet={isDeviceSmallerThanTablet} />}
          modalCustomWidth={768}
          hideHeader={true}
        />
      )}
    </>
  );
};

export default BlackFridayBanner;
